import { Component, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import {
    AccountSelectors,
    AccountState,
    ModulesSelectors,
} from '@serviceos-ng/core';
import { Observable, pipe } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'serviceos-web-names',
    templateUrl: './names.component.html',
    styleUrls: ['./names.component.scss'],
})
export class NamesComponent implements OnInit {
    @Select(AccountSelectors.names)
    names$!: Observable<any>;

    texts$!: Observable<{
        my_account: string;
    }>;

    constructor(private store: Store) {
        
    }

    ngOnInit(): void {
        this.texts$ = this.store
            .select(ModulesSelectors.getModuleByName('account'))
            .pipe(
                map((config) => {
                    return {
                        my_account: config.texts.my_account || 'My Account',
                    };
                })
            );
    }
}
